import axios from 'axios'
import qs from 'qs'
import store from '@/store'
import { $Message  } from '@/utils/message';
import { getToken } from '@/utils/auth'

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 10000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    // 参数处理
    if (store.state.token) {
      config.headers['token'] = getToken()
    }
    if (config.method === 'post') {
      // 去除值为空的参数
      for (const key in config.data) {
        if (!config.data[key] && config.data[key] !== 0) {
          delete config.data[key]
        }
      }

      // post方法以formData形式提交
      if (config.dataType === 'form') {
        config.data = qs.stringify(config.data)
        delete config.dataType
      }
    } else if (config.method === 'get') {
      for (const key in config.params) {
        if (!config.params[key] && config.params[key] !== 0) {
          delete config.params[key]
        }
      }
    }
    return config
  },
  error => {
    console.log(error) // for debug
    return Promise.reject(error)
  }
)


// response interceptor
service.interceptors.response.use(
  response => {
    const res = response.data
    if (res && res.code !== 0) {
      if (res.code === 101) {
        $Message({
          message: '登录已过期',
          type: 'error',
          duration: 2 * 1000,
          onClose() {
            if (window.location.href.indexOf('login') === -1) {
              store.dispatch('resetUserInfo')
            }
          }
        })
      } else {
        $Message({
          message: res.msg || 'Error',
          type: 'error',
          duration: 2 * 1000,
          onClose() {
            if (res.code === 101 && window.location.href.indexOf('login') === -1) {
              store.dispatch('resetUserInfo')
            }
          }
        })
        return res
      }
    } else {
      return res
    }
  },
  error => {
    $Message({
      message: error.response.data ? error.response.data.message : error.message,
      type: 'error',
      duration: 3 * 1000
    })
    return Promise.reject(error)
  }
)

export default service
